import React, { forwardRef, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

const FilterWorkExperienceHcForwardRef = (props, ref) => {
  const { params } = props;

  const initial = params.initialValue || {};
  const [name, setName] = useState(initial.name ?? "");
  const [companyName, setCompanyName] = useState(initial.companyName ?? "");

  useImperativeHandle(ref, () => ({
    getFilter() {
      const filter = {};
      if (name || companyName) {
        filter.userFieldsOfWorks = {};
        if (name) {
          filter.userFieldsOfWorks.name = { like: `%${name}%` };
        }
        if (companyName) {
          filter.userFieldsOfWorks.companyName = { like: `%${companyName}%` };
        }
      }
      return filter;
    },
    getValue() {
      if (!name && !companyName) return null;
      return { name, companyName };
    },
    getDisplayValue() {
      const parts = [];
      if (name) parts.push(`b: ${name}`);
      if (companyName) parts.push(`m: ${companyName}`);
      if (!parts.length) return null;
      return `${params.name}: ${parts.join(", ")}`;
    },
  }));

  return (
    <Grid container spacing={2}>
      <Grid>
        <label className={` col-form-label fw-bold fs-6`}>{params.name}</label>
      </Grid>
      <Grid className={`fv-row`}>
        <Grid container alignItems={"center"}>
          <Grid>
            <FormControl sx={{ width: 150 }}>
              <TextField
                type="text"
                name={`${params.field}-name`}
                autoComplete="off"
                onChange={(event) => {
                  setName(event.target.value ?? "");
                }}
                label={"Beosztás"}
                value={name}
              />
            </FormControl>
          </Grid>
          <Grid>
            <FormControl sx={{ width: 150 }}>
              <TextField
                type="text"
                name={`${params.field}-companyName`}
                autoComplete="off"
                onChange={(event) => {
                  setCompanyName(event.target.value ?? "");
                }}
                label={"Munkahely"}
                value={companyName}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
const FilterWorkExperienceHc = forwardRef(FilterWorkExperienceHcForwardRef);

FilterWorkExperienceHc.propTypes = {
  params: PropTypes.object,
};

export default FilterWorkExperienceHc;
